import { Select } from "antd";
import styles from "./_WorkflowFilterBar.less";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { filtrarWorkflow, filtroSelector, workflowSelector } from "../../store/workflow";
import useDispatchWithResult from "../../hooks/useDispatchWithResult";
import { useTranslation } from "react-i18next";

export default function WorkflowFilterBarModulo() {
  const { t } = useTranslation();
  const dispatch = useDispatchWithResult();
  const workflow = useSelector(workflowSelector);
  const filtro = useSelector(filtroSelector);
  const [modulos, setModulos] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    const modulosFixos = [
      { id: "societario", label: "Societário" },
      { id: "regulatorio", label: "Regulatório" },
      { id: "compliance", label: "Compliance" },
    ];
    setModulos(modulosFixos);
  }, []);

  const handleChange = (modulos) => {
    dispatch(filtrarWorkflow({ modulos }));
  };

  return (
    <Select allowClear className={styles["select"]} filterOption={false} mode="multiple" searchValue={searchValue} onSearch={setSearchValue} showSearch value={filtro.modulos} onChange={handleChange}>
      {modulos.map((modulo) => (
        <Select.Option key={modulo.id} value={modulo.d}>
          {t(modulo.label)}
        </Select.Option>
      ))}
    </Select>
  );
}
